import React, { useState } from 'react';
import query from 'query-string';
import Utils from '../../helpers/Utils';
import Input from '../../components/Input';
import Button from '../../components/Button';
import useAPI from '../../hooks/useAPI';
import {useFormatter} from '../../hooks/useFormatter';
import AuthPage, {AuthLink} from '../../components/AuthPage';
import TwoFactorAuth from '../../components/TwoFactorAuth';

export default function Login()
{
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [challengeName,setChallengeName] = useState('');
    const [challengeType,setChallengeType] = useState('');
    const [challengeTrustToken,setChallengeTrustToken] = useState('');
    const [challengeLast4, setChallengeLast4] = useState('');
    const [busy, setBusy] = useState(false);
    const [errors, setErrors] = useState({
        page: '',
        email: '',
        password: ''
    });
    const api = useAPI();
    const formatter = useFormatter();

    const handleLoginSuccess = (data)=>{
        api.clearCookies();
        api.storeAuthData(data);
        api.setSessionSettings({
            menu_closed: false
        });
        let params = query.parse(window.location.search);
        if( params.return_url ){
            window.location = params.return_url;
        }else{
            window.location = '/?from=login';
        }
    }

    const login = (e)=>{
        e.preventDefault();

        let _errors = {};
        if( ! email ){
            _errors.email =  "Email address required";
        }else if( ! Utils.emailValid(email) ){
            _errors.email = "Email address invalid";
        }

        if( ! password ){
            _errors.password =  "Password required";
        }

        if( Object.keys(_errors).length ){
            return setErrors(_errors);
        }

        setBusy(true);

        api.json('POST', '/auth/login', {
            email: email,
            password: password
        })
        .then(r=>r.json())
        .then((response)=>{
            if(response.errors){
                setBusy(false);

                return setErrors({
                    ...formatter.flattenErrors(response.errors)
                });
            }

            //  Check for challenges
            if(response.data.challenge){
                setChallengeName(response.data.challenge.name);
                setChallengeType(response.data.challenge.type);
                setChallengeTrustToken(response.data.challenge.trust_token);
                setChallengeLast4(response.data.challenge?.last_4 || '');

                setBusy(false);

                return;
            }

            handleLoginSuccess(response.data);
        })
        .catch((error)=>{
            alert(error);
            setBusy(false)
        });
    }

    if(challengeName === 'TWO_FACTOR_AUTH'){
        return (
            <TwoFactorAuth 
                type={challengeType} 
                trusttoken={challengeTrustToken}
                last4={challengeLast4}
                onSuccess={(data)=>{
                    handleLoginSuccess(data);
                }}
                onCancel={()=>{
                    window.location.reload(true);
                }}
            />
        )
    }

    return(
        <>
            <AuthPage error={errors.page} style={{filter: challengeName === 'TWO_FACTOR_AUTH' ? 'blur(5px)' : 'none'}}>
                <form onSubmit={login} disabled={busy}>
                    <div className="row">
                        <div className="col-12">
                            <Input
                                error={errors.email}
                                label="Email Address"
                                maxLength="128"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                    setErrors({...errors, email: ''});
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <Input
                                error={errors.password}
                                type="password"
                                label="Password"
                                maxLength="40"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrors({...errors, password: ''})
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <Button
                                className="button-primary button-full"
                                onClick={login}
                                busy={busy}
                            >Sign In</Button>
                        </div>
                    </div>
                </form>
                {( errors.contract_status && <div className="row">
                    <div className="col-12 text-center">
                        <span className="input-error">{errors.contract_status}</span>
                    </div>
                </div> )}
                <div className="row">
                    <div className="col-12">
                        <AuthLink to={`/forgot-password`}>Forgot Password</AuthLink>
                    </div>
                </div>
            </AuthPage>
        </>
    );
}